module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor28-9e97d0e42231850d98cd19920e0eaf79.jpg";